import { z } from 'zod'

/**
 * URL search params for the Custom Dashboards surface — deep-linkable (project
 * convention). The active dashboard id lives in the URL, validated here. There is no
 * edit-mode flag: widgets are draggable/resizable at all times (PostHog-style).
 */
export const customDashboardsSearchSchema = z.object({
	/** Active dashboard id; when absent the user's default (or first) loads. */
	dashboard: z.string().optional(),
	/** Widget id the Builder is editing (edit mode); absent ⇒ authoring a new widget. */
	widget: z.string().optional(),
	/**
	 * The Library's active tab — UI state, deep-linkable so the
	 * sidebar and the "+ Add" menu can land on a specific tab. Absent ⇒
	 * dashboards, the mock's resting state. Not persisted: `wire-schema.ts`
	 * has no part in this.
	 */
	tab: z.enum(['dashboards', 'widgets']).optional(),
})

export type LibraryTab = NonNullable<
	z.infer<typeof customDashboardsSearchSchema>['tab']
>
